<template>
  <v-app-bar
    class="app-bar"
    color="white"
    dark
    elevation-1
    :height="step ? '80' : ''"
  >
    <v-container :class="step ? 'app-bar--wrapper' : ''">
      <v-toolbar-title class="app-bar__title">
        <img
         src="@/assets/img/logo-full-dark.svg"
         alt="Bench logo"
         :class="step ? 'app-bar__img' : ''">
      </v-toolbar-title>
      <v-toolbar-items>
        <BarStepper v-if="step"/>
      </v-toolbar-items>
    </v-container>s
  </v-app-bar>
</template>

<script>
import BarStepper from '@/components/BarStepper.vue';

export default {
  components: {
    BarStepper,
  },

  props: {
    step: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.app-bar {
  box-shadow: 0px 2px 4px #00000029;
  &__title {
    line-height: 1;
  }
  &__img {
    width: 90px;
    @include tablet {
      width: auto;
    }
  }
  &--wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
